export default __webpack_public_path__ + "static/media/hand.f4e96ab3.svg";